export const ArrowLeft = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.273438 8.28125C0.078125 8.08594 0 7.85156 0 7.57812C0 7.34375 0.078125 7.10938 0.273438 6.91406L7.14844 0.351562C7.53906 0 8.125 0 8.47656 0.390625C8.82812 0.742188 8.82812 1.36719 8.4375 1.71875L3.24219 6.64062H16.5625C17.0703 6.64062 17.5 7.07031 17.5 7.57812C17.5 8.125 17.0703 8.51562 16.5625 8.51562H3.24219L8.4375 13.4766C8.82812 13.8281 8.82812 14.4141 8.47656 14.8047C8.125 15.1953 7.53906 15.1953 7.14844 14.8438L0.273438 8.28125Z"
      fill="currentColor"
    />
  </svg>
);
